import { ForSaleScreen } from "@/app/modules/Purchases/ForSaleScreen.tsx";

export const ForSale = () => {
  return <ForSaleScreen />;
};
